const nlpEnvs = ['local', 'dev', 'staging', 'prod'];
export {};
//# sourceMappingURL=types.js.map